import { render } from "./FotoFileForm.vue?vue&type=template&id=03333f6a&scoped=true"
import script from "./FotoFileForm.vue?vue&type=script&lang=js"
export * from "./FotoFileForm.vue?vue&type=script&lang=js"

import "./FotoFileForm.vue?vue&type=style&index=0&id=03333f6a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03333f6a"]])

export default __exports__